import type { SVGProps } from 'react';

const SvgFileProxy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M20 9c-.55 0-1 .45-1 1v8c0 .55-.45 1-1 1h-6.18c.11-.31.18-.65.18-1v-3c0-1.65-1.35-3-3-3H6c-.35 0-.69.07-1 .18V6c0-.55.45-1 1-1h8c.55 0 1-.45 1-1s-.45-1-1-1H6C4.35 3 3 4.35 3 6v12c0 1.65 1.35 3 3 3h12c1.65 0 3-1.35 3-3v-8c0-.55-.45-1-1-1M6 19c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1z"
    />
    <path
      fill="currentcolor"
      d="M14 8c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1h-.59l3.29-3.29a.996.996 0 1 0-1.41-1.41L14 8.59z"
    />
  </svg>
);
export default SvgFileProxy;
